module.exports = __webpack_public_path__ + "static/img/ent-detail-11.2d06b9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-11.jpg
// module id = ZnNp
// module chunks = 51